$(document).ready(function () {
  $('.slick-banner')
  .on('init', function () {
    $('.upper_headr').addClass('slick-ready');
  })
  .slick({
    rtl: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 6000,
    cssEase: 'linear',
    infinite: true,
    arrows: false,
    dots: false,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 733,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  const discountModal = document.getElementById('exampleModal');

  if (discountModal && !sessionStorage.getItem('popupClosed')) {
    const modal = new bootstrap.Modal(discountModal);

    setTimeout(() => {
      modal.show();
    }, 1000);

    discountModal.addEventListener('hidden.bs.modal', function () {
      sessionStorage.setItem('popupClosed', 'true');
    });
  }
  
  // Read More / Read Less

  // $(".read-more-btn").on("click", function () {
  //   const paragraphWrapper = $(this).prev(".hide_text");
  //   const button = $(this);

  //   if (paragraphWrapper.hasClass("expanded")) {
  //     paragraphWrapper
  //       .css("height", "1em")
  //       .removeClass("expanded");
  //     button.text("Read more");
  //   } else {
  //     const fullHeight = paragraphWrapper[0].scrollHeight;
  //     paragraphWrapper
  //       .css("height", fullHeight + "px")
  //       .addClass("expanded");
  //     button.text("Read less");
  //   }
  // });

  let clickedElement = null;
  let clicked = false;
  let cartTextChanged = false;
  let activeBoxPrice = null;

  const findShadowElement = (path, parentClass, elementClass = '') => {
    let element = null;
    for (const el of path) {
      if (el instanceof HTMLElement) {
        if (el.classList.contains(parentClass)) {
          if (elementClass != '') {
            const child = el.querySelector(`.${elementClass}`);
            if (child) {
              element = el;
              break;
            }
          }
          else {
            element = el;
            break;
          }
        }
      }
    }

    return element;
  }

  const styleChange = (element, attribute, value) => {
    if (
      element && element.style[attribute] != value
    ) {
      element.style.setProperty(
        attribute, value, "important"
      );
    }
  }

  const resetAllColour = (shadowRoot) => {
    const allSelects = [];
    const allPrice = [];
    const allPriceOld = [];

    shadowRoot
      .querySelectorAll(".beez-select")
      .forEach((s) => allSelects.push(s));
    shadowRoot
      .querySelectorAll(".beez-plan-price")
      .forEach((s) => allPrice.push(s));
    shadowRoot
      .querySelectorAll(".beez-plan-price-old")
      .forEach((s) => allPriceOld.push(s));

    // Reset all
    allSelects.forEach((select) => {
      // styleChange(select, "color", "#424242");
      styleChange(select, "color", "#999");
    });

    allPrice.forEach((select) => {
      styleChange(select, "color", "#FFFFFF4D");
    });

    allPriceOld.forEach((select) => {
      styleChange(select, "color", "#FFFFFF4D");
    });
  }

  const applyActiveColour = (subBox) => {
    const activeSelect = subBox.querySelector(".beez-select");
    // styleChange(activeSelect, "color", "#c2c2c2");
    styleChange(activeSelect, "color", "#fff");

    const activePrice = subBox.querySelector(".beez-plan-price");
    activeBoxPrice = activePrice;
    styleChange(activePrice, "color", "#fff");

    const activePriceOld = subBox.querySelector(".beez-plan-price-old");
    styleChange(activePriceOld, "color", "#999");
  }

  const updateAddToCartBtn = () => {
    let cartText = document.querySelector(
      ".add-to-cart-text .add-to-cart-text__content"
    );

    let editedText =
      `${cartText?.getAttribute("data-original-text")} - ${activeBoxPrice.textContent.trim()}`;

    if (cartText && activeBoxPrice && cartText.innerHTML != editedText) {
      cartText.innerHTML = editedText;
      cartTextChanged = true;
    }
  }

  const beezObserver = new MutationObserver((mutations) => {

    // Guard check: Avoid running processing loops if mutations are just style adjustments
    const hasStructuralChanges = mutations.some(mutation =>
      mutation.type === "childList" ||
      (mutation.type === "attributes" && mutation.attributeName != "style")
    );

    if (!hasStructuralChanges) return;

    const wrapper = document.querySelector(".pd_con_wrp");

    if (!wrapper) return;

    // Only hide when widget exists
    const shadowRoot = document?.querySelector("#subscribee-widget div")?.shadowRoot;
    const tierList = shadowRoot?.querySelector(".beez-tier-list");
    let firstSubPlan = shadowRoot?.querySelector(".beez-sub-box");

    if (
      !clickedElement?.classList.contains("beez-tier-card") &&
      !clicked
    ) {
      if (tierList) {

        let tierName = tierList.querySelector(".beez-tier-name");

        const qtySelect = document.querySelector("#qty_select");

        // Fix: Only update if the text is actually different to prevent childList refires
        if (qtySelect && tierName && qtySelect.textContent != tierName.textContent) {
          qtySelect.textContent = tierName.textContent;
        }

        const subCounter = document.querySelector(".subscrip_counter");
        styleChange(subCounter, "display", "block");

        document.querySelectorAll(".counter-box, .qty_txt").forEach((el) => {
          styleChange(el, "display", "none");
        });
      } else {
        const btnWrp = document.querySelector(".btn_wrp:has(.counter-box)");
        styleChange(btnWrp, "display", "block");

        const qtyInput = document.querySelector(".counter-box quantity-selector-component input");
        styleChange(qtyInput, "display", "block");
      }
    }

    if (
      !clickedElement?.classList.contains("beez-sub-box") &&
      !clicked
    ) {
      if (firstSubPlan) {

        let subCard = firstSubPlan;

        let subPrice = subCard.querySelector(
          ".beez-plan-price"
        );
        activeBoxPrice = subPrice;

        let subPriceOld = subCard.querySelector(
          ".beez-plan-price-old"
        );

        styleChange(subPrice, "color", "#fff");
        styleChange(subPriceOld, "color", "#999");

        if (!cartTextChanged) {
          updateAddToCartBtn();
        }
      }
    }

    // Attach listener only once
    if (!wrapper.dataset.beezListenerAttached) {
      wrapper.dataset.beezListenerAttached = "true";

      wrapper.addEventListener("click", (e) => {
        const path = e.composedPath();
        const subBox = findShadowElement(path, "beez-sub-box");
        const tier = findShadowElement(path, "beez-tier-card", "beez-tier-name");


        if (subBox) {
          clickedElement = subBox;
          clicked = true;

          resetAllColour(shadowRoot);
          applyActiveColour(subBox);
        }

        if (tier) {
          clickedElement = tier;
          clicked = true;
          const qtySelect = document.getElementById("qty_select");
          const tierName = tier?.querySelector(".beez-tier-name");

          if (qtySelect && tierName && qtySelect.textContent != tierName.textContent) {
            qtySelect.textContent = tierName.textContent;
          }
        }

        if (subBox || tier) {
          updateAddToCartBtn();
        }
      });

      shadowRoot?.addEventListener("change", (e) => {
        const select = e.target.closest(".beez-select");
        if (!select) return;

        const path = e.composedPath();
        resetAllColour(shadowRoot);
        styleChange(select, "color", "#fff");
        const subBox = findShadowElement(path, "beez-sub-box");
        applyActiveColour(subBox);
        updateAddToCartBtn();
      });
    }
  });

  beezObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    // Ignores "style" attribute mutations completely!
    attributeFilter: ["class", "id"]
  });

  function mobileOnlySlider() {
    if ($(window).width() <= 575) {
      if (!$('.mble_ftr_sldr').hasClass('slick-initialized')) {
        $('.mble_ftr_sldr').slick({
          dots: true,
          arrows: false,
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1
        });
      }
    } else {
      if ($('.mble_ftr_sldr').hasClass('slick-initialized')) {
        $('.mble_ftr_sldr').slick('unslick');
      }
    }
  }

  // Run on loadr
  mobileOnlySlider();

  // Run on resize
  $(window).on('resize', function () {
    mobileOnlySlider();
  });

  document.body.addEventListener('click', function (e) {
    var btn = e.target.closest('.ajax-add-to-cart');
    if (!btn) return;
    e.preventDefault();
    const originalText = btn.textContent;
    var variantId = btn.getAttribute('data-variant-id');
    var inStock = parseInt(btn.getAttribute('data-item-availabilty'));
    var cartCount = parseInt(btn.getAttribute('data-item-cart-count'));
    let quantity = 1;
    let quantity_wrap = btn.closest('.qty_wrp');
    if (quantity_wrap) {
      quantity = parseInt(document.getElementById('qtyInput').value);
    }

    let totalAmount = cartCount + quantity;

    if (totalAmount <= inStock) {
      btn.textContent = "ADDING...";
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {

          // Update cart count (your .crtNum span)
          fetch('/cart.js')
            .then(function (res) { return res.json(); })
            .then(function (cart) {
              var cartCountEls = document.querySelectorAll('.crtNum span');
              cartCountEls.forEach(function (el) {
                el.textContent = cart.item_count;
              });
            });

          // Button feedback
          // btn.innerText = 'ADDED TO CART';
          // setTimeout(function () {
          btn.textContent = originalText;
          // }, 1500);
          const elements = document.querySelectorAll(`.success_cls[data-variant-id="${variantId}"]`);
          const buttons = document.querySelectorAll(`.ajax-add-to-cart[data-variant-id="${variantId}"]`);
          elements.forEach((el, index) => {
            el.textContent = "Successfully added";
            el.classList.add("active");
            buttons[index].setAttribute('data-item-cart-count', totalAmount);
            setTimeout(function () {
              el.classList.remove("active");
            }, 1500);
          });
        })
        .catch(function (error) {
          console.error('Add to cart error:', error);
        });
    }
    else {
      const elements = document.querySelectorAll(`.error_msg_cls[data-variant-id="${variantId}"]`);
      elements.forEach(el => {
        el.textContent = "Item out of stock";
        el.classList.add("active");
        setTimeout(function () {
          el.classList.remove("active");
        }, 1500);
      });
    }
  });


  (function () {
    const originalFetch = window.fetch;

    window.fetch = function (...args) {
      return originalFetch.apply(this, args).then(async (response) => {
        try {
          const url = typeof args[0] === "string" ? args[0] : args[0].url;

          if (url?.includes("/cart/add.js") || url?.includes("/cart/change") || url?.includes("/cart/change.js")) {
            const cloned = response.clone();
            const data = await cloned.json();

            // Inspect Shopify response
            if (data.status == 422 || response.status == 422) {
              fetch('/cart.js')
                .then(function (res) { return res.json(); })
                .then(function (cart) {
                  var cartCountEls = document.querySelectorAll('.crtNum span');
                  cartCountEls.forEach(function (el) {
                    el.textContent = cart.item_count;
                  });
                });
            }
          }
        } catch (err) {
          console.error("Fetch intercept error:", err);
        }

        return response;
      });
    };
  })();


  let productWrap = document.getElementById('productWrap');
  let filterWrap = document.querySelector('.topPrt.fr_fltr');

  async function fetchProducts(url) {
    try {
      let link = new URL(url);
      link.searchParams.set('view', 'fetch-products');
      const res = await fetch(link);
      const html = await res.text();

      // Parse and inject only the product container
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      let newProducts = doc.getElementById('productWrap');

      if (newProducts) {
        productWrap.innerHTML = newProducts.innerHTML;
      }
    } catch (err) {
      console.error('Error fetching products:', err);
    }
  }
  
  if (productWrap) {

    let url = new URL(window.location.href);
    let allTagTabs = document.querySelectorAll('#tag_filter .tag_tab');

    if (allTagTabs.length > 0) {
      allTagTabs.forEach((item) => {
        item.addEventListener('click', function () {
          const tagHandle = this.getAttribute("data-tag");
          allTagTabs.forEach((tab) => {
            tab.classList.remove("active");
          });
          item.classList.add("active");
          // Base collection path
          let pathParts = url.pathname.split('/');
          // Remove existing tag if already present
          if (pathParts.length > 3) {
            pathParts.pop();
          }
          // Add new tag
          pathParts.push(tagHandle);
          const newPath = pathParts.join('/');
          url.pathname = newPath;

          // Update browser URL
          history.pushState({}, '', url);
          // Fetch products
          fetchProducts(url);
        });
      });
    }

    if (filterWrap) {

      const filterSelect = document.getElementById('filter');
      let stockCheckbox = document.getElementById("chackValOne");
      let mobileStockCheckbox = document.getElementById("mble_chackValOne");
      let rangeMin = document.getElementById('range-min');
      let rangeMax = document.getElementById('range-max');
      let inputMin = document.getElementById('input-min');
      let inputMax = document.getElementById('input-max');
      let mobileRangeMin = document.getElementById('mble_range-min');
      let mobileRangeMax = document.getElementById('mble_range-max');
      let mobileInputMin = document.getElementById('mble_input-min');
      let mobileInputMax = document.getElementById('mble_input-max');

      const availability = url.searchParams.get('filter.v.availability');
      const sortBy = url.searchParams.get('sort_by');
      const min = url.searchParams.get('filter.v.price.gte');
      const max = url.searchParams.get('filter.v.price.lte');

      if (min) {
        [rangeMin, mobileRangeMin, inputMin, mobileInputMin].forEach((input) => {
          input.value = min;
        });
      }

      if (max) {
        [rangeMax, mobileRangeMax, inputMax, mobileInputMax].forEach((input) => {
          input.value = max;
        });
      }

      if (sortBy) {
        $('#filter').selectpicker('val', sortBy);
        const radio = document.querySelector(`input[name="foo"][value="${sortBy}"]`);
        if (radio) {
          radio.checked = true;
        }
      }

      if (availability) {
        stockCheckbox.checked = true;
        mobileStockCheckbox.checked = true;
      }

      filterSelect.addEventListener('change', function () {
        const selectedValue = this.value;
        url.searchParams.set('sort_by', selectedValue);
        history.pushState({}, '', url);
        fetchProducts(url);
      });

      stockCheckbox.addEventListener("change", function () {
        if (this.checked) {
          url.searchParams.set('filter.v.availability', 1);
        }
        else {
          url.searchParams.delete('filter.v.availability');
        }
        history.pushState({}, '', url);
        fetchProducts(url);
      });

      // Debounce function
      function debounce(func, delay) {
        let timeout;
        return function (...args) {
          clearTimeout(timeout);
          timeout = setTimeout(() => func.apply(this, args), delay);
        };
      }

      // Handler function
      function rangeChange(min, max) {
        if (min !== null) {
          url.searchParams.set('filter.v.price.gte', min);
        }
        if (max !== null) {
          url.searchParams.set('filter.v.price.lte', max);
        }

        history.pushState({}, '', url);
        fetchProducts(url);
      }

      const debouncedUpdateRange = debounce((min, max) => rangeChange(min, max), 500);

      let mobileFilter = document.getElementById('fillterModal');

      const mobileApply = document.getElementById('mbl_fltr_aply');
      mobileApply.addEventListener('click', () => {
        scrollToTop();
        // Modal Close Start 
        const modalElement = document.getElementById('fillterModal');
        const modalInstance = bootstrap.Modal.getInstance(modalElement)
          || new bootstrap.Modal(modalElement);

        modalInstance.hide();

        // Modal Close End 
        url.searchParams.set('sort_by', document.querySelector('input[name="foo"]:checked').value);
        if (mobileStockCheckbox.checked) {
          url.searchParams.set('filter.v.availability', 1);
        }
        else {
          url.searchParams.delete('filter.v.availability');
        }

        url.searchParams.set('filter.v.price.gte', mobileInputMin.value);
        url.searchParams.set('filter.v.price.lte', mobileInputMax.value);

        history.pushState({}, '', url);
        fetchProducts(url);
      });

      ////////////////////////////////////////// Shop Range Slider JS ///////////////////////////////////////////////////////////

      $(".rangePriceWrap").each(function () {
        let container = $(this);
        let rangeInput = container.find(".range-input input");
        let priceInput = container.find(".price-input input");
        let range = container.find(".range_slider .progress");
        let priceGap = 1;

        // priceInput.on("change", function () {
        //   let minPrice = parseInt(priceInput.eq(0).val());
        //   let maxPrice = parseInt(priceInput.eq(1).val());

        //   if (
        //     maxPrice - minPrice >= priceGap &&
        //     maxPrice <= rangeInput.eq(1).attr("max")
        //   ) {
        //     if ($(this).hasClass("input-min")) {
        //       rangeInput.eq(0).val(minPrice);
        //       range.css(
        //         "left",
        //         (minPrice / rangeInput.eq(0).attr("max")) * 100 + "%",
        //       );
        //     } else {
        //       rangeInput.eq(1).val(maxPrice);
        //       range.css(
        //         "right",
        //         100 - (maxPrice / rangeInput.eq(1).attr("max")) * 100 + "%",
        //       );
        //     }
        //   }
        // });

        rangeInput.on("input", function () {
          let minVal = parseInt(rangeInput.eq(0).val());
          let maxVal = parseInt(rangeInput.eq(1).val());

          if (maxVal - minVal < priceGap) {
            if ($(this).hasClass("range-min")) {
              rangeInput.eq(0).val(maxVal - priceGap);
              minVal = maxVal - priceGap;
            } else {
              rangeInput.eq(1).val(minVal + priceGap);
              maxVal = minVal + priceGap;
            }
          }

          priceInput.eq(0).val(minVal);
          priceInput.eq(1).val(maxVal);

          debouncedUpdateRange(priceInput.eq(0).val(), priceInput.eq(1).val());

          range.css({
            left: (minVal / rangeInput.eq(0).attr("max")) * 100 + "%",
            right: 100 - (maxVal / rangeInput.eq(1).attr("max")) * 100 + "%",
          });
        });

        // Initial progress bar update
        let initialMin = parseInt(rangeInput.eq(0).val());
        let initialMax = parseInt(rangeInput.eq(1).val());
        range.css({
          left: (initialMin / rangeInput.eq(0).attr("max")) * 100 + "%",
          right: 100 - (initialMax / rangeInput.eq(1).attr("max")) * 100 + "%",
        });
      });


      ////////////////////////////////////////// Shop Range Slider JS ///////////////////////////////////////////////////////////

      function scrollToTop() {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }

      function enforceMinMax(inputMin, inputMax, rangeMin, rangeMax) {

        const MIN = Number(inputMin.min) || 0;
        const MAX = Number(inputMax.max) || 100;
        const GAP = 1;

        function normalize() {
          let minVal = inputMin.value === "" ? null : Number(inputMin.value);
          let maxVal = inputMax.value === "" ? null : Number(inputMax.value);
          let range = document.querySelector(".range_slider .progress");

          if (minVal !== null) {
            minVal = Math.max(MIN, Math.min(minVal, MAX - GAP));
          }

          if (maxVal !== null) {
            maxVal = Math.min(MAX, Math.max(maxVal, MIN + GAP));
          }

          if (minVal !== null && maxVal !== null && minVal >= maxVal) {
            maxVal = minVal + GAP;
          }

          if (minVal !== null) {
            inputMin.value = minVal;
            rangeMin.value = minVal;
            range.style.left =
              (minVal / rangeMin.getAttribute("max")) * 100 + "%";
          }

          if (maxVal !== null) {
            inputMax.value = maxVal;
            rangeMax.value = maxVal;
            range.style.right =
              100 - (maxVal / rangeMax.getAttribute("max")) * 100 + "%";
          }

          debouncedUpdateRange(minVal, maxVal);
        }

        inputMin.addEventListener("change", () => normalize());
        inputMax.addEventListener("change", () => normalize());
      }

      enforceMinMax(inputMin, inputMax, rangeMin, rangeMax);
      enforceMinMax(mobileInputMin, mobileInputMax, mobileRangeMin, mobileRangeMax);
    }
  }

  function clickJMButton() {
    const button = document.querySelector(
      '.jm-button.jm-button--primary.jm-action-buttons__button'
    );

    if (button) {
      button.click();
    }
    // else {
    //   console.log('JM button not found');
    // }
  }



  // document.addEventListener("DOMContentLoaded", function () {
  //   document.getElementById("move_to_review").addEventListener("click", function (e) {
  //     e.preventDefault();

  //     const target = document.getElementById("judgeme_product_reviews");
  //     const offset = 80; // header height
  //     const position = target.getBoundingClientRect().top + window.pageYOffset - offset;

  //     window.scrollTo({
  //       top: position,
  //       behavior: "smooth"
  //     });

  //     clickJMButton();
  //   });
  // });


  const buttons = document.querySelectorAll(".view_rat");

  buttons.forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();

      const target = document.getElementById("judgeme_product_reviews");
      const offset = 80; // header height
      const position = target.getBoundingClientRect().top + window.pageYOffset - offset;

      window.scrollTo({
        top: position,
        behavior: "smooth"
      });
    });
  });


  const reviews = document.getElementById("judgeme_product_reviews");
  if (reviews) {
    reviews.classList.add("container");
  }

  const qtyInput = document.querySelector('input[name="quantity"]');
  if (qtyInput) {
    qtyInput.readOnly = true;
  }

  // Observe only to init bootstrap-select
  const observer = new MutationObserver(() => {
    const $select = $("#judgeme_product_reviews select");

    if ($select.length && !$select.hasClass("selectpicker")) {
      $select.addClass("selectpicker");
      $select.selectpicker();
      observer.disconnect(); // safe now
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Event delegation for dynamic buttons
  document.body.addEventListener("click", (e) => {
    // Open review modal
    if (e.target.closest('.jm-button[type="button"]')) {
      document.body.classList.add("rview_mdl_cls");
    }

    // Close review modal
    if (e.target.closest('.jdgm-write-review-modal__close-btn')) {
      document.body.classList.remove("rview_mdl_cls");
    }
  });
});
